import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import screenshots from "../assets/screenshots";

function Hero() {
  const { t, locale } = useLanguage();

  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <div className="badge">{t.hero.badge}</div>
        <h1>{t.hero.title}</h1>
        <p>{t.hero.description}</p>
        <p>{t.hero.descriptionSecondary}</p>
        <div className="hero-actions">
          <a href="#download" className="btn btn-dark">
            {t.hero.ctaPrimary}
          </a>
          <a href="#features" className="btn btn-light">
            {t.hero.ctaSecondary}
          </a>
        </div>
      </div>

      <div className="hero-visual">
        <div className="phone-mockup">
          <img
            src={screenshots[locale].mobileHome}
            alt={t.hero.mockupAlt}
            className="screen-shot"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
